import { Badge } from 'foundations-components/transitional/components/Badge';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getReleaseStatus } from '../../utils/releaseUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ReleaseRibbon(props) {
  const {
    approvalType
  } = props;
  const releaseStatus = getReleaseStatus(approvalType);
  if (releaseStatus === 'BETA') {
    return /*#__PURE__*/_jsx(Badge, {
      use: "koala",
      marginInlineStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.beta"
      })
    });
  }
  if (releaseStatus === 'NEW') {
    return /*#__PURE__*/_jsx(Badge, {
      use: "koala",
      marginInlineStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.new"
      })
    });
  }
  return null;
}